export const BUS_SAVED_VIEW_UPDATE = "saved-view:update"
